/* Vienna Set theme: menu, product carousel, product page.
   Uses delegated events so it keeps working inside the theme editor. */
(function () {
  'use strict';

  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }

  /* ---------- menu ---------- */
  function setMenu(open) {
    var menu = document.getElementById('site-menu');
    var btn = document.querySelector('[data-menu-toggle]');
    if (!menu || !btn) return;
    menu.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  /* ---------- carousel ---------- */
  function step(rail, dir) {
    var slide = rail.querySelector('[data-slide]');
    if (!slide) return;
    var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 24;
    rail.scrollBy({ left: dir * (slide.offsetWidth + gap), behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    var toggle = closest(t, '[data-menu-toggle]');
    if (toggle) {
      var menu = document.getElementById('site-menu');
      setMenu(menu ? menu.hidden : false);
      return;
    }
    if (closest(t, '#site-menu a')) { setMenu(false); return; }
    if (!closest(t, '#site-menu')) { setMenu(false); }

    var prev = closest(t, '[data-rail-prev]');
    var next = closest(t, '[data-rail-next]');
    if (prev || next) {
      var section = closest(t, '.collection');
      var rail = section && section.querySelector('[data-rail]');
      if (rail) step(rail, prev ? -1 : 1);
      return;
    }

    var sPrev = closest(t, '[data-strip-prev]');
    var sNext = closest(t, '[data-strip-next]');
    if (sPrev || sNext) {
      var strip = closest(t, '.strip');
      var row = strip && strip.querySelector('.strip__row');
      var item = row && row.querySelector('.strip__item');
      if (row && item) {
        var g = parseFloat(getComputedStyle(row).columnGap || getComputedStyle(row).gap) || 16;
        row.scrollBy({ left: (sPrev ? -1 : 1) * (item.offsetWidth + g), behavior: 'smooth' });
      }
      return;
    }

    var opt = closest(t, '[data-opt]');
    if (opt) {
      var slide = closest(opt, '[data-slide]');
      if (!slide) return;
      slide.querySelectorAll('[data-opt]').forEach(function (o) {
        o.setAttribute('aria-pressed', o === opt ? 'true' : 'false');
      });
      var img = slide.querySelector('.media__img');
      var src = opt.getAttribute('data-image');
      if (img && src) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = src; }
      var buy = slide.querySelector('[data-buy]');
      var href = opt.getAttribute('data-href');
      if (buy && href) buy.setAttribute('href', href);
      return;
    }

    var thumb = closest(t, '[data-thumb]');
    if (thumb) { showMedia(thumb.getAttribute('data-thumb')); return; }

    var pdpNav = closest(t, '[data-pdp-prev], [data-pdp-next]');
    if (pdpNav) {
      var stage = closest(pdpNav, '.pdp__stage');
      var slides = stage ? Array.prototype.slice.call(stage.querySelectorAll('.pdp__slide')) : [];
      if (slides.length > 1) {
        var idx = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
        if (idx < 0) idx = 0;
        var dir = pdpNav.hasAttribute('data-pdp-next') ? 1 : -1;
        var target = slides[(idx + dir + slides.length) % slides.length];
        showMedia(target.getAttribute('data-media-id'));
      }
      return;
    }

    var pdpZoom = closest(t, '[data-pdp-zoom]');
    if (pdpZoom) {
      var zStage = closest(pdpZoom, '.pdp__stage');
      var active = zStage && zStage.querySelector('.pdp__slide.is-active');
      if (active) openLightbox(active.getAttribute('data-full'), active.getAttribute('data-caption'));
      return;
    }

    var sizeOpen = closest(t, '[data-size-chart-open]');
    if (sizeOpen) {
      var modal = document.getElementById('size-chart-modal');
      if (modal) { modal.hidden = false; document.body.classList.add('lb-open'); }
      return;
    }
    var sizeModal = document.getElementById('size-chart-modal');
    if (sizeModal && !sizeModal.hidden && (closest(t, '[data-size-chart-close]') || t === sizeModal)) {
      sizeModal.hidden = true;
      document.body.classList.remove('lb-open');
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    var rail = closest(e.target, '[data-rail]');
    if (!rail) return;
    if (e.key === 'ArrowRight') { e.preventDefault(); step(rail, 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); step(rail, -1); }
  });

  /* ---------- product page ---------- */
  function showMedia(id) {
    if (!id) return;
    document.querySelectorAll('.pdp__slide').forEach(function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(id));
    });
    document.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-thumb') === String(id));
    });
  }

  function variantsFor(root) {
    var el = root.querySelector('[data-variants]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (err) { return []; }
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    var root = closest(input, '[data-product]');
    if (!root || !input.matches('[data-option-index]')) return;

    var groups = root.querySelectorAll('[data-option-group]');
    var chosen = [];
    groups.forEach(function (g) {
      var checked = g.querySelector('input:checked');
      chosen.push(checked ? checked.value : null);
      var label = g.querySelector('[data-option-label]');
      if (label && checked) label.textContent = checked.value.toLowerCase();
    });

    var match = variantsFor(root).filter(function (v) {
      return chosen.every(function (val, i) { return v.options[i] === val; });
    })[0];

    var add = root.querySelector('[data-add]');
    var idInput = root.querySelector('[data-variant-id]');
    var price = root.querySelector('[data-price]');
    var compare = root.querySelector('[data-compare]');

    if (!match) {
      if (add) {
        add.disabled = true;
        var noLabel = add.querySelector('[data-add-label]');
        if (noLabel) { noLabel.textContent = 'Unavailable'; } else { add.textContent = 'Unavailable'; }
      }
      return;
    }
    if (idInput) idInput.value = match.id;
    if (price) price.textContent = match.price;
    if (compare) {
      compare.textContent = match.compare || '';
      compare.hidden = !match.compare;
    }
    if (add) {
      add.disabled = !match.available;
      var addLabel = add.querySelector('[data-add-label]');
      var text = match.available ? 'Add to cart' : 'Sold out';
      if (addLabel) { addLabel.textContent = text; } else { add.textContent = text; }
    }
    if (match.media) showMedia(match.media);

    if (window.history && history.replaceState) {
      var url = root.getAttribute('data-product-url');
      if (url) history.replaceState(null, '', url + '?variant=' + match.id);
    }
  });
  /* ---------- big photo pop-up ---------- */
  var lightbox = null;
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.body.classList.remove('lb-open');
    var img = lightbox.querySelector('.lightbox__img');
    if (img) img.removeAttribute('src');
  }
  function openLightbox(src, caption) {
    if (!src) return;
    if (!lightbox) {
      lightbox = document.createElement('div');
      lightbox.className = 'lightbox';
      lightbox.setAttribute('role', 'dialog');
      lightbox.setAttribute('aria-modal', 'true');
      lightbox.hidden = true;
      lightbox.innerHTML = '<button type="button" class="lightbox__close" aria-label="Close" data-lightbox-close>&times;</button>' +
        '<figure class="lightbox__fig"><img class="lightbox__img" alt=""><figcaption class="lightbox__cap"></figcaption></figure>';
      document.body.appendChild(lightbox);
    }
    var img = lightbox.querySelector('.lightbox__img');
    var cap = lightbox.querySelector('.lightbox__cap');
    img.src = src;
    img.alt = caption || '';
    cap.textContent = caption || '';
    cap.hidden = !caption;
    lightbox.hidden = false;
    document.body.classList.add('lb-open');
    var closeBtn = lightbox.querySelector('.lightbox__close');
    if (closeBtn) closeBtn.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var trigger = closest(t, '[data-lightbox]');
    if (trigger) {
      e.preventDefault();
      openLightbox(trigger.getAttribute('data-full'), trigger.getAttribute('data-caption'));
      return;
    }
    if (lightbox && !lightbox.hidden && (closest(t, '[data-lightbox-close]') || t === lightbox)) closeLightbox();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeLightbox();
      var sizeModalEsc = document.getElementById('size-chart-modal');
      if (sizeModalEsc && !sizeModalEsc.hidden) {
        sizeModalEsc.hidden = true;
        document.body.classList.remove('lb-open');
      }
    }
  });

  /* ---------- drag to scroll (photo strip, mouse only) ---------- */
  (function () {
    var row = null, startX = 0, startLeft = 0, moved = false;
    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      var r = closest(e.target, '[data-drag-scroll]');
      if (!r) return;
      row = r; startX = e.clientX; startLeft = r.scrollLeft; moved = false;
    });
    document.addEventListener('pointermove', function (e) {
      if (!row) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; row.classList.add('is-dragging'); }
      if (moved) row.scrollLeft = startLeft - dx;
    });
    function end() {
      if (!row) return;
      row.classList.remove('is-dragging');
      row = null;
    }
    document.addEventListener('pointerup', end);
    document.addEventListener('pointercancel', end);
    document.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  })();
})();
